import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocale } from "../i18n/LocaleProvider";
import type { AppLocale } from "../i18n/locale";

/** Fixed control on public Podscope reports and media kits. */
export function PublicLanguageChrome() {
  const { publicSurface, showToggle } = useLocale();
  if (!publicSurface || !showToggle) return null;
  return (
    <Box sx={{ position: "fixed", top: 12, right: 16, zIndex: 1300 }}>
      <LanguageToggle />
    </Box>
  );
}

const LanguageToggle: React.FC = () => {
  const { t } = useTranslation("common");
  const { locale, showToggle, setLocale } = useLocale();
  if (!showToggle) return null;

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={locale}
      aria-label={t("language.label")}
      onChange={(_event, next: AppLocale | null) => {
        if (next) setLocale(next);
      }}
      sx={{
        bgcolor: "background.paper",
        "& .MuiToggleButton-root": {
          px: 1,
          py: 0.25,
          fontSize: "0.75rem",
          lineHeight: 1.6,
        },
      }}
    >
      <ToggleButton value="es" aria-label={t("language.es")}>
        {t("language.es")}
      </ToggleButton>
      <ToggleButton value="en" aria-label={t("language.en")}>
        {t("language.en")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default LanguageToggle;
